import { render, staticRenderFns } from "./ValueCommercerList.vue?vue&type=template&id=176fd055&scoped=true"
import script from "./ValueCommercerList.vue?vue&type=script&lang=js"
export * from "./ValueCommercerList.vue?vue&type=script&lang=js"
import style0 from "./ValueCommercerList.vue?vue&type=style&index=0&id=176fd055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176fd055",
  null
  
)

export default component.exports